import React, { useContext, useEffect, useState } from "react"
import PropTypes from 'prop-types'
import momentPropTypes from 'react-moment-proptypes'
import moment from 'moment'
import DateFieldRange from "../../../common/forms/DateFieldRange"
import { SEARCH, SearchContext } from "../SearchContext"
import {
  calcNightsMoment
} from '../../../common/helpers/formHelper'

const MAX_NIGHTS = 30

const SearchCalendar = ({departure, setDeparture, activateMe}) => {
  const { state: { arrival }, dispatch } = useContext(SearchContext)
  const _setArrival = (payload) =>
    dispatch({ type: SEARCH.ARRIVAL.SET, payload })
  const _setNights = (payload) => dispatch({ type: SEARCH.NIGHTS.SET, payload })
  const [focusedInput, setFocusedInput] = useState(null)

  useEffect(() => {
    if(activateMe) {
      setFocusedInput("startDate")
    }
  }, [activateMe])

  const _onDatesChange = ({ startDate, endDate }) => {
    if(startDate) {
      if (startDate < moment().hours(0)) return false
      _setArrival(startDate)

      let minDeparture = moment(startDate).add(1, 'days')
      setDeparture(minDeparture)
    }

    if(endDate) {
      let nights = calcNightsMoment(arrival, endDate)
      if (nights > MAX_NIGHTS) {
        nights = MAX_NIGHTS
        endDate = moment(startDate).add(MAX_NIGHTS, 'days')
      }
      setDeparture(endDate)
      _setNights(nights)
    }
  }

  const _onFocusChange = focusedInput => setFocusedInput(focusedInput)

  return (
    <label className="arrival dates">
      <div className="fields-icon-wrapper">
        <i className="far fa-calendar-alt main-icon" />
        <DateFieldRange
          startDate     = {arrival}
          startDateId   = "arrival"
          endDate       = {departure}
          endDateId     = "departure"
          onDatesChange = {_onDatesChange}
          focusedInput  = {focusedInput}
          onFocusChange = {_onFocusChange}
          displayFormat = { () => 'MMM Do'}
          startDatePlaceholderText = "Arrival"
          endDatePlaceholderText   = "Departure"
          withPortal
        />
      </div>
    </label>
  )
}

SearchCalendar.propTypes = {
  departure: momentPropTypes.momentObj,
  setDeparture: PropTypes.func.isRequired,
  activateMe: PropTypes.bool
}

export default SearchCalendar
